import { Component, OnInit, Input } from '@angular/core';
import { AlertService } from '../../Services/alert.service';
import { Alert, AlertType } from '../models/alert';

// import { Alert, AlertType } from '../_models/index';
// import { AlertService } from '';

@Component({
    // moduleId: module.id,
    selector: 'alert',
    template: require('./alert.component.html')
})

export class AlertComponent {
    @Input() id: string;

    alerts: Alert[] = [];

    constructor(private alertService: AlertService) { }

    ngOnInit() {
        this.alertService.getAlert(this.id).subscribe((alert: Alert) => {
            if (!alert.message) {
                // clear alerts when an empty alert is received
                this.alerts = [];
                return;
            }

            // add alert to array
            this.alerts.push(alert);
        });
    }

    removeAlert(alert: Alert) {
        this.alerts = this.alerts.filter(x => x !== alert);
    }

    cssClass(alert: Alert) {
        if (!alert) {
            return;
        }

        // return css class based on alert type
        switch (alert.type) {
            case AlertType.Success:
                return 'alert alert-success';
            case AlertType.Error:
                return 'alert alert-danger';
            case AlertType.Info:
                return 'alert alert-info';
            case AlertType.Warning:
                return 'alert alert-warning';
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/alerts/alert.component.ts